<template>
    <div>
        <step-header :title="$t(`${currentStep.name}.title`)" button-id="popover-info" />
        <engage-popover
            :header="$t(`${currentStep.name}.title`)"
            :intro1="$t(`${currentStep.name}.intro1`)"
            placement="bottom"
            target="popover-info"
        />

        <div class="row justify-content-center my-2">
            <div class="col-md-10 overflow-auto h-100">
                <div class="row m-0 justify-content-center overview-rounded">
                    <div class="col-xl-6 my-1">
                        <div class="d-flex flex-column overview-rounded shadow px-1 pb-1">
                            <div class="d-flex flex-row align-items-center my-1 mr-1">
                                <b-avatar
                                    :text="resolveInitials($t(`engage.select-template.modal-title`))"
                                    class="mx-1 preview-avatar"
                                    size="md"
                                    variant="info"
                                />
                                <h6 class="m-0 p-0">{{ $t(`engage.select-template.modal-title`) }}</h6>
                            </div>
                            <message-preview
                                :attachments="currentStep.editedTemplate.attachments"
                                :components="currentStep.editedTemplate.template.components"
                                :date="currentDateFull"
                                :message="currentStep.editedTemplate.template.content"
                            />
                        </div>
                    </div>
                    <div class="col-xl-6 my-1 d-flex flex-column justify-content-between">
                        <overview-info-box
                            :header="$t(`engage.overview.your-engage-message-name`) + ':'"
                            :text="currentStep.nameEngage.messageName"
                            class="mb-1"
                            color-class="overview-message"
                            icon="user-group"
                            shadowed-box-class="py-2"
                        >
                            <template v-slot:title>
                                <div class="d-flex align-items-center">
                                    <h6 class="p-0 m-0">{{ $t(`engage.overview.your-engage-message-name`) }}:</h6>
                                    <b-button
                                        v-if="currentStep.nameEngage.description"
                                        id="engage-desctiption"
                                        class="ml-1 p-0 info-square"
                                        size="sm"
                                        variant="primary"
                                    >
                                        i
                                    </b-button>
                                    <b-popover
                                        placement="bottomleft"
                                        target="engage-desctiption"
                                        triggers="hover focus"
                                        variant="dark"
                                    >
                                        <template #default>
                                            <div class="popover-body-container">
                                                <h6 class="text-white mb-1">
                                                    {{ currentStep.nameEngage.messageName }}
                                                </h6>
                                                <p class="text-white">
                                                    <small>{{ currentStep.nameEngage.description }}</small>
                                                </p>
                                            </div>
                                        </template>
                                    </b-popover>
                                </div>
                            </template>
                        </overview-info-box>
                        <overview-info-box
                            :header="$t(`engage.overview.channel-selected`) + ':'"
                            :text="currentStep.selectedChannel.channel.name"
                            class="mb-1"
                            color-class="overview-channel"
                            shadowed-box-class="py-2"
                        >
                            <template v-slot:icon>
                                <p class="p-0 m-0 saysimple-icon whatsapp x-large text-white"></p>
                            </template>
                        </overview-info-box>
                        <overview-info-box
                            :header="$t(`engage.overview.selected-approved-template`) + ':'"
                            :text="currentStep.editedTemplate.template.title"
                            class="mb-1"
                            color-class="overview-template"
                            icon="grid-2"
                            shadowed-box-class="py-2"
                        />
                        <overview-info-box
                            :header="$t(`engage.overview.your-contact-list`) + ':'"
                            :text="currentStep.selectedContactList.contactList.name"
                            class="mb-1"
                            color-class="overview-contacts"
                            icon="address-book"
                            shadowed-box-class="py-2"
                        >
                            <template v-slot:description>
                                <div class="d-flex">
                                    <p class="p-0 m-0 engage-font-md text-secondary">
                                        {{ currentStep.selectedContactList.contactList.name }}
                                    </p>
                                </div>
                                <p class="p-0 m-0 engage-font-md text-primary">
                                    {{ $tc("engage.overview.contacts-opt-in", receiveEngageMessagesList.length) }}
                                </p>
                                <template v-if="ignoreEngageMessagesList.length > 0">
                                    <div class="p-0 m-0 engage-font-md text-danger">
                                        {{ $tc("engage.overview.contacts-opt-out", ignoreEngageMessagesList.length) }}
                                        <b-button
                                            id="opted-out-contacts-info"
                                            class="p-0 info-square ml-25"
                                            size="sm"
                                            variant="primary"
                                            >i
                                        </b-button>
                                        <b-popover
                                            placement="bottom"
                                            target="opted-out-contacts-info"
                                            triggers="hover focus"
                                            variant="white"
                                        >
                                            <h3>
                                                {{
                                                    $tc(
                                                        "engage.overview.contacts-opt-out",
                                                        ignoreEngageMessagesList.length
                                                    )
                                                }}
                                            </h3>
                                            <small
                                                >{{
                                                    ignoreEngageMessagesList
                                                        .map((contact) => `${contact.name} (${contact.phone})`)
                                                        .join("\r\n")
                                                }}
                                            </small>
                                        </b-popover>
                                    </div>
                                </template>
                            </template>
                        </overview-info-box>
                        <div class="d-flex flex-column">
                            <div
                                class="d-flex mb-1 shadow align-items-center overview-rounded p-1 pl-2 overview-info-wrapper"
                            >
                                <div
                                    class="d-flex flex-column align-items-center justify-items-center m-1 shadow overview-info"
                                >
                                    <div class="bg-primary py-25 px-2 text-white font-weight-bold overview-rounded-top">
                                        <p class="p-0 m-0">{{ sentAtDate }}</p>
                                    </div>
                                    <div class="p-75">
                                        <h3 class="p-0 m-0">{{ sentAtMonthDay }}</h3>
                                    </div>
                                </div>
                                <div class="d-flex flex-column ml-1">
                                    <h6 class="p-0 m-0">{{ $t(`engage.overview.time`) }}:</h6>
                                    <h1 class="m-0 p-0">{{ sendAtTime }}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BAvatar, BButton, BPopover } from "bootstrap-vue";
import engagePopover from "../../components/engagePopover.vue";
import stepHeader from "../components/stepHeader.vue";
import messagePreview from "../components/messagePreview.vue";
import overviewInfoBox from "../components/overviewInfoBox.vue";
import lodash from "lodash";
import { formatDate } from "@/utils/luxon";
import { DateTime } from "luxon";
import { resolveInitials } from "@/utils/users";
import useEngageForm from "../../useEngageForm";
import { onMounted, ref } from "@vue/composition-api";

export default {
    components: {
        BButton,
        BPopover,
        BAvatar,
        engagePopover,
        stepHeader,
        messagePreview,
        overviewInfoBox,
    },
    setup() {
        const { currentStep } = useEngageForm();

        const [receiveEngageMessagesList, ignoreEngageMessagesList] = lodash.partition(
            currentStep.value.selectedContactList.contactList.contacts,
            (contact) => contact.allowSystemMessages
        );

        const popoverShow = ref(false);
        const onPopoverClose = () => {
            popoverShow.value = false;
        };
        const initDateTime = () => {
            return currentStep.value.schedule.isScheduled ? currentStep.value.schedule.dateTime : DateTime.now();
        };
        const sendAtDateTime = ref(initDateTime());

        const currentDateFull = formatDate(sendAtDateTime.value, DateTime.DATE_FULL);
        const sendAtTime = formatDate(sendAtDateTime.value, DateTime.TIME_SIMPLE);
        const sentAtDate = sendAtDateTime.value.monthShort + " " + sendAtDateTime.value.year;
        const sentAtMonthDay = sendAtDateTime.value.day;

        onMounted(() => {
            sendAtDateTime.value = initDateTime();
        });

        return {
            resolveInitials,
            currentStep,
            receiveEngageMessagesList,
            ignoreEngageMessagesList,
            onPopoverClose,
            sentAtMonthDay,
            sentAtDate,
            sendAtTime,
            currentDateFull,
        };
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/modules/engage/messageOverview.scss";
@import "~@/assets/scss/modules/engage/messagePreview.scss";
</style>
